
import { useGlobalStore } from '@/modules/globalModule/store';
import { defineComponent } from 'vue';
import { useNodeCanvasStore } from '../store';
import { Node } from './storeClasses/node';
export default defineComponent({
  name: 'EditNodeBox',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    languagePython: boolean;
    ncStore: ReturnType<typeof useNodeCanvasStore>;
    globalStore: ReturnType<typeof useGlobalStore>;
    nodeToEdit: Node | undefined;
    name: string;
    isInspectActive: boolean;
  } {
    return {
      languagePython: true,
      ncStore: useNodeCanvasStore(),
      globalStore: useGlobalStore(),
      nodeToEdit: undefined,
      name: '',
      isInspectActive: false
    };
  },
  methods: {
    open() {
      const globalStore = useGlobalStore();
      this.nodeToEdit = globalStore.getNode(this.ncStore.editingNodeId);
      if (this.nodeToEdit === undefined) {
        this.exit();
        return;
      }
      this.name = this.nodeToEdit.name;
      this.languagePython = this.nodeToEdit.language === 'py';
    },
    exit() {
      this.ncStore.editingNodeId = 'undefined';
    },
    setLanguage(languagePython: boolean) {
      this.languagePython = languagePython;
    },
    saveAndExit() {
      this.save();
      this.exit();
    },
    save() {
      if (!this.nodeToEdit) return;
      this.nodeToEdit.name = this.name;
      this.nodeToEdit.setLanguage(this.languagePython ? 'py' : 'cpp');
    },
    openCode() {
      this.save();
      this.$router.push(
        `/codeView/${this.$route.params.workspaceID}?elemId=${this.ncStore.editingNodeId}`
      );
    }
  },
  watch: {
    active() {
      if (this.active) this.open();
    }
  }
});
